import { Application } from './Application';
import { ProgramMembership } from './Membership';
import { User } from './User';

export enum Format {
	HTML = 'html',
	MD = 'md',
}

export type PostedBy = 'user' | 'mentibot' | 'application';

export enum PostAttachmentFileType {
	UNKNOWN = 'unknown',
	PDF = 'pdf',
	IMAGE = 'image',
}

export enum PostStatus {
	DRAFT = 'draft',
	PUBLISHED = 'published',
}

export interface PostAttachment {
	id: number;
	postId: number;
	postUuidLink: string | null;
	fileType: PostAttachmentFileType;
	storagePathname: string | null;
	originalFileName: string;
	originalFileSize: number;
	createdAt: Date;
}

export interface PostAttachmentLocal extends Omit<PostAttachment, 'id' | 'postId' | 'storagePathname'> {
	id?: number;
	postId?: number;
	localUuid: string;
	storagePathname?: string | null;
}

type ApplicationReciever = Pick<Application, 'id'> & {
	programMembership: Pick<ProgramMembership, 'id'> & {
		user: Pick<User, 'id' | 'email' | 'firstName' | 'lastName'>;
	};
};

export interface Post {
	id: number;
	language: 'pl' | 'en';
	format: Format;
	menteeAccess: boolean;
	mentorAccess: boolean;
	postedBy: PostedBy;
	programId: number;
	programType: string;
	text: string;
	title: string;
	updatedAt: Date;
	user: UserData;
	userId: number | null;
	applications?: Application[];
	status?: PostStatus;
	publishedAt?: Date | null;
	applicationRecievers?: ApplicationReciever[];
	pinnedAt?: Date | null;

	attachments?: PostAttachment[];
	preComments?: {
		data: PostComment[];
		meta: { page: number; nextPage: number | null; left: number };
	};
	comments?: PostComment[];
}

export interface PostComment {
	id: number;
	postId: number;
	text: string;
	userId: number;
	user: User;
	createdAt: Date;
	updatedAt: Date;
}

export interface UserData {
	id: number;
	avatar: string | null;
	firstName: string;
	lastName: string;
}
